import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-time-lined",
  "use": "rt-base-circle-time-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-circle-time-lined\"><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m265.9 713.9c-34.6 34.6-74.8 61.7-119.5 80.6C612 878.1 562.8 888 512 888s-100-9.9-146.3-29.5c-44.8-18.9-85-46.1-119.5-80.6-34.6-34.6-61.7-74.8-80.6-119.5C145.9 612 136 562.8 136 512s9.9-100 29.5-146.3c18.9-44.8 46.1-85 80.6-119.5 34.6-34.6 74.8-61.7 119.5-80.6C412 145.9 461.2 136 512 136s100 9.9 146.3 29.5c44.8 18.9 85 46.1 119.5 80.6 34.6 34.6 61.7 74.8 80.6 119.5C878.1 412 888 461.2 888 512s-9.9 100-29.5 146.3c-19 44.8-46.1 85-80.6 119.6z\" /><path d=\"M750 466H558V274c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-time-lined.svg
// module id = 1671
// module chunks = 228